<template>
    <div>
        <h1>Amine</h1>
        <p>
            Amine sind Formen des Ammoniaks (NH<sub>3</sub>), bei denen ein oder
            mehrere H-Atome gegen organische Molekülgruppen ausgetauscht werden,
            oft durch einen
            <router-link to="aromaten">Benzolring</router-link>.<br />
            Wichtig ist vor allem das
            <router-link to="#herstellung-von-anilin">Anilin</router-link>,
            welches aus einem Benzolring mit einer Aminogruppe (-NH<sub>2</sub>)
            besteht. In der Industrie wird es als Ausgangsstoff für die
            Herstellung von Farben, Kunststoffen und Medikamenten genutzt.
        </p>
        <img
            src="@/assets/img/stoffe/amine/anilin.png"
            width="125px"
            height="auto"
            alt="Anilin: Ein wichtiges Amin"
            title="Anilin: Ein wichtiges Amin"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Herstellung von Anilin"></chapter-heading>
        <img
            src="@/assets/img/stoffe/amine/anilin-herstellung.png"
            alt="Die Herstellung von Anilin"
            title="Die Herstellung von Anilin"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen der Amine"></chapter-heading>
        <ul>
            <li>
                als Reaktoren bei zahlreichen
                <router-link to="/reaktionen/nucleophilen-substitutionen"
                    >nucleophilen Substitutionen</router-link
                >
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>
                            basiert auf Ammoniak, aber mit organischen
                            Molekülgruppen statt dem H-Atom
                        </li>
                        <li>einfachste Form ist das Anilin</li>
                        <li>
                            ein oder mehrere H-Atome können ersetzt werden
                            (primäre, sekundäre und tertiäre Amine)
                        </li>
                        <li>
                            Reaktion als Base wegen dem freien Elektronenpaar am
                            N-Atom möglich
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Summenformel</th>
                <td>R-NH<sub>2</sub></td>
            </tr>
            <tr>
                <th>Anilin</th>
                <td>
                    <ul>
                        <li>NH<sub>2</sub> + Benzolring</li>
                        <li>schlecht wasserlöslich</li>
                        <li>Grundbaustein von Farben</li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
